import { post } from "mdui/api/HttpReq";
import { getExchangeRate } from "./rtCbft";
import ApplicantAccountInfoContent from "./acctInfoModel"
import { rssiApiCall, translateFormMsg } from "./wuiUtils";
import { AlertType } from "core/components/MsgBox.tsx";
import { buildAttr } from "./rtCbft";
import { reloadCtrlCfg } from "./wuiUtils";
import YesNoModel from 'functions/YesNoModel';
import { getField } from "mdui/form/Util";


const feeCalculation = async ({ props, formData, updateState, config, setCfg, ...data }) => {
    let val = await post('fee-cal', 'list', { ...formData, module: props.field.moduleId })
    let { errors, ...restVal } = val
    let newFormData = {
        ...formData,
        ...restVal
    }
    let nattr = { ...data.attr }
    let fields = ['creditAmt']

    // Reset fields from original attr without err
    for (let field of fields) {
        if (data.attr?.[field]) {
            let originalAttr = { ...data.attr[field] }
            delete originalAttr.err
            nattr[field] = originalAttr
        }
    }
    if (errors && typeof errors === 'object') {

        for (let [fieldName, errorCode] of Object.entries(errors)) {
            let attributes = nattr[fieldName] || {}
            delete attributes['err'];
            nattr[fieldName] = { ...attributes, err: errorCode };
        }

    }
    updateState({ newFormData, newAttr: nattr })
}
const feeAndExchangeRateCalculation = async ({ props, formData, updateState, config, setCfg, clearForm, loadCfg, modNm, mtype, ...data }) => {

    let exchgVal = await post('exchg-rate-cal', 'list', formData)
    let formDataAfterExchg = { ...formData }

    if (exchgVal) {
        formDataAfterExchg = {
            ...formData,
            ...exchgVal
        }
    }
    let { procMode, ...restFormDataAfterExchg } = formDataAfterExchg

    let feeVal = await post('fee-cal', 'list', { ...restFormDataAfterExchg, module: props.field.moduleId })
    let { errors, ...restFeeVal } = feeVal

    let newFormData = {
        ...restFormDataAfterExchg,
        ...restFeeVal
    }

    // Fallback: if backend didn't return debitAmt / netPymtAmt, mirror creditAmt
    if (newFormData.debitAmt === null || newFormData.debitAmt === undefined || newFormData.debitAmt === '') {
        newFormData.debitAmt = newFormData.creditAmt
    }
    if (newFormData.netPymtAmt === null || newFormData.netPymtAmt === undefined || newFormData.netPymtAmt === '') {
        newFormData.netPymtAmt = newFormData.creditAmt
    }

    let nattr = { ...data.attr }
    let fields = ['creditAmt', 'debitAmt', 'netPymtAmt']

    for (let field of fields) {
        if (data.attr?.[field]) {
            let originalAttr = { ...data.attr[field] }
            delete originalAttr.err
            nattr[field] = originalAttr
        }
    }

    if (errors && typeof errors === 'object') {
        for (let [fieldName, errorCode] of Object.entries(errors)) {
            let attributes = nattr[fieldName] || {}
            delete attributes['err']
            nattr[fieldName] = { ...attributes, err: errorCode }
        }
    }

    updateState({ newFormData, newAttr: nattr })
}

const creditCcyOnChange = async ({ props, ctrlCfg, formData, updateState, config, setCfg, ...data }) => {

    var hasErorr = await rtHolidayChk({
        ...data,
        props,
        formData: formData,
        updateState,
        config,
        setCfg,
    });
    if (hasErorr) {
        return;
    }
    let rssiResp = await rssiApiCall({ props, ctrlCfg, formData, updateState, config, setCfg, ...data })

    let newFormData = {
        ...formData,
        rssiRspnData: JSON.stringify(rssiResp),
        ...rssiResp,
        creditRate: '',
        debitRate: '',
        txFee: '',
        fxContractRefNum: '',
        creditAmt: data.isFromPrefCorrBic ? '':formData.creditAmt,
        rcvrCorrBic: '',
        trxnCcy: formData.debitCcy
    }

    let { newFormData: feeCalculationFormData } = await getExchangeRate({ props, formData: newFormData, updateState, config, setCfg, ...data })
    let feeCalculationAttr = await buildAttr({ formData: feeCalculationFormData, args: 'ccy' })
    let keyLabelArray = [];
    if (rssiResp.rcvrCorrBicList && typeof rssiResp.rcvrCorrBicList === 'string') {
        let rcvrCorrBicList = JSON.parse(rssiResp.rcvrCorrBicList);
        Object.keys(rcvrCorrBicList).forEach((e) => {
            if (e && typeof e === 'string') {
                keyLabelArray.push({
                    val: e,
                    lbl: rcvrCorrBicList[e]
                })
            }
        })
    }
    feeCalculationFormData = { ...feeCalculationFormData, ...rssiResp, dynSelectRecCorsBic: keyLabelArray }
    if (rssiResp && rssiResp.rssiRspnStatus && rssiResp.rssiRspnStatus === '00') {
        updateState({ newFormData: feeCalculationFormData, newAttr: {...feeCalculationAttr, sndrCorrBic: {} } })
        return;
    } else if (rssiResp && rssiResp.rssiRspnStatus && rssiResp.rssiRspnStatus !== '00') {
        let appendErrorMsg = rssiResp.rssiRespDesc.startsWith("Unable") ? '' : translateFormMsg('rssi_error_msg');
        let newMsg = { key: appendErrorMsg + rssiResp.rssiRespDesc, type: AlertType.W };
        updateState({ newFormData: feeCalculationFormData, newMsg, newAttr: feeCalculationAttr  })
        return;
    } else {
        let newMsg = { key: translateFormMsg('rssi_error_msg') + ": " + rssiResp.rssiRespDesc, type: AlertType.W };
        updateState({ newFormData: feeCalculationFormData, newMsg, newAttr: feeCalculationAttr  })
        return;
    }
}
const debitCcyOnChange = async ({ props, formData, updateState, config, setCfg, ...data }) => {
    let newFormData = {
        ...formData,
        creditRate: '',
        debitRate: '',
        txFee: '',
        fxContractRefNum: '',
        creditAmt: '',
        creditCcy: '',
        trxnCcy: formData.debitCcy
    }
    updateState({ newFormData })
}

const debtCcyChange = async ({ props, formData, ctrlCfg, updateState, config, setCfg, ...data }) => {
    let newFormData = {
        ...formData,
        creditRate: '',
        debitRate: '',
        txFee: '',
        fxContractRefNum: '',
        creditAmt: '',
        creditCcy: '',
        trxnCcy: formData.debitCcy
    };

    if (formData.debitCcy == null || formData.debitCcy == '') {
        const fld = getField(config.pages[config.cPKey].config, props.field?.callbackArgs ?? 'creditCcy');
        let newCtrlCfg = ctrlCfg;
        if (fld) {
            const key = `${fld.moduleId}_${fld.name}`;
            newCtrlCfg = { ...ctrlCfg, [key]: [] };
        }
        updateState({ newFormData, newCtrlCfg });
        return;
    }

    var hasErorr = await rtHolidayChk({
        ...data,
        props,
        formData: newFormData,
        updateState,
        config,
        setCfg,
    });
    if (hasErorr) {
        return;
    }
    let { newFormData: feeCalculationFormData } = await getExchangeRate({ props, formData: newFormData, updateState, config, setCfg, ...data })

    const callbackArgs = props.field?.callbackArgs ?? 'creditCcy';
    await reloadCtrlCfg({
        ...data,
        props: {
            ...props,
            field: { ...props.field, callbackArgs },
        },
        formData: { ...feeCalculationFormData },
        ctrlCfg,
        config,
        updateState,
        setCfg,
    });
};
const debtCcyChangeFromGetAcctInfo = async ({ props, formData, ctrlCfg, updateState, config, setCfg, ...data }) => {
    let newFormData = {
        ...formData,
        creditRate: '',
        debitRate: '',
        txFee: '',
        fxContractRefNum: '',
        creditAmt: '',
        trxnCcy: formData.debitCcy
    };
   var hasErorr = await rtHolidayChk({
    ...data,
    props,
    formData: newFormData,
    updateState,
    config,
    setCfg,
});
if (hasErorr) {
    return;
}
let { newFormData: feeCalculationFormData } = await getExchangeRate({ props, formData: newFormData, updateState, config, setCfg, ...data })

    const callbackArgs = props.field?.callbackArgs ?? 'creditCcy';
    await reloadCtrlCfg({
        ...data,
        props: {
            ...props,
            field: { ...props.field, callbackArgs },
        },
        formData: {...feeCalculationFormData},
        ctrlCfg,
        config,
        updateState,
        setCfg,
    });
};

const getAcctInfoChkr = async ({ props, formData, updateState, config, setCfg, validate, showCustomModal, hideCustomModal, ...data }) => {
    formData = { ...formData, cifNumber: formData.dbtrCifid }


    //const fieldsToValidate = ["acctFr", "dbtrCifid"];
    /*	const isValid = validate(fieldsToValidate);
        if (isValid) {*/
    if (validate({ valFields: ["acctFr", "acctFrType"] })) {
        let payload = {
            acctFr: formData.acctFr,
            acctFrType: formData.acctFrType,
            chnlInstrId: formData.chnlInstrId,
            applID: 'ACCINQRY',
            chnlInd: 'PGBZOP',
        }

        console.log("payloadingetAcctInfo", payload)
        let val = await post('get-acct-info', 'read', payload)
        console.log('getAcctInfo val', val)

        // account codes
        const savingAcct = [110, 111, 112, 113, 114, 116];
        const currentAcct = [216, 220];

        if (val && val.debtAccType && savingAcct.includes(val.debtAccType)) {
            val = { ...val, debtAccType: 'Saving Account' }

        } else if (val && val.debtAccType && currentAcct.includes(val.debtAccType)) {
            val = { ...val, debtAccType: 'Current Account' }
        }



        let debtRssntStts = '';
        if (val.debtResStts === "Y") {
            debtRssntStts = '0'; // Saving
        } else {
            debtRssntStts = '1'; // Current
        }
        let component =

            <ApplicantAccountInfoContent
                data={val}
                onClose={hideCustomModal}
            />
        showCustomModal({ content: component });
		let newFormData = {
			...formData,
			dbtrName: val.debtAccName,
			debitCcy: val.debtAccCurr,
			dbtShortName: val.shortName,
			dbtPriAccName: val.pAccName,
			dbtrRsdntStts: debtRssntStts,
			acctFrType: val.debtAccType,   // uncomment/add explicitly if you need it
			cifNumber: val.cifNumber,      // add any other specific debtor fields you actually need, one by one
		};

        console.log('getAcctInfo newFormData', newFormData)

    }
    /*    }*/
}

const getAcctInfo = async ({ props, formData, updateState, config, setCfg, validate, showCustomModal, hideCustomModal, ...data }) => {
    formData = { ...formData, cifNumber: formData.dbtrCifid }


    //const fieldsToValidate = ["acctFr", "dbtrCifid"];
    /*	const isValid = validate(fieldsToValidate);
        if (isValid) {*/
    if (validate({ valFields: ["acctFr", "acctFrType"] })) {
        let payload = {
            acctFr: formData.acctFr,
            acctFrType: formData.acctFrType,
            chnlInstrId: formData.chnlInstrId,
            applID: 'ACCINQRY',
            chnlInd: 'PGBZOP',
        }

        console.log("payloadingetAcctInfo", payload)
        let val = await post('get-acct-info', 'read', payload)
        console.log('getAcctInfo val', val)

        // account codes
        const savingAcct = [110, 111, 112, 113, 114, 116];
        const currentAcct = [216, 220];

        if (val && val.debtAccType && savingAcct.includes(val.debtAccType)) {
            val = { ...val, debtAccType: 'Saving Account' }

        } else if (val && val.debtAccType && currentAcct.includes(val.debtAccType)) {
            val = { ...val, debtAccType: 'Current Account' }
        }



        let debtRssntStts = '';
        if (val.debtResStts === "Y") {
            debtRssntStts = '0'; // Saving
        } else {
            debtRssntStts = '1'; // Current
        }
        let component =

            <ApplicantAccountInfoContent
                data={val}
                onClose={hideCustomModal}
            />
        showCustomModal({ content: component });
        const { debtAccType, ...restVal } = val;
        let newFormData = {
            ...formData,
            dbtrName: val.debtAccName,
            //		acctFrType: val.debtAccType,
            debitCcy: val.debtAccCurr,
            dbtShortName: val.shortName,
            dbtPriAccName: val.pAccName,
            dbtrRsdntStts: debtRssntStts,
            ...restVal
        };
        let attr = {
            dbtrRsdntStts: {readOnly: true },
    dbtShortName: {readOnly: true },
    dbtPriAccName: {readOnly: true },
        }
        updateState({ newFormData, newAttr:attr})


        

        await debtCcyChangeFromGetAcctInfo({ props, formData: newFormData, updateState, config, setCfg, ...data })
    }
    /*    }*/
}

const attrBicHandle = async ({ props, ctrlCfg, formData, updateState, config, setCfg, ...data }) => {
    let bankBic = formData.acctToBic

    if (bankBic === '') {
        let clearedFormData = {
            ...formData,
            cdtrBnkNm: '',
            cdtrBnkCntrycd: '',
            cdtrBnkAddr1: '',
            cdtrBnkAddr2: ''
        }
        updateState({ newFormData: clearedFormData })
        return;
    }

    let param = { fiBic: bankBic }

    let res = await post('md-mod-cfg', 'read', { ...param, initOpr: 'edit', module: 'bnkdir-cfg', action: 'edit', page: 0, perPage: 10 });

    if (res.content.length > 0) {
        let resObj = res.content[0]

        let newFormData = {
            ...formData,
            cdtrBnkNm: resObj.fiName,
            cdtrBnkCntrycd: resObj.cntryCd,
            cdtrBnkAddr1: resObj.addressLine1,
            cdtrBnkAddr2: resObj.addressLine2
        }
        if (formData && formData.creditCcy && formData.creditCcy !== '') {
            let rssiResp = await rssiApiCall({ props, ctrlCfg, formData: {...formData, rcvrCorrBic: ''}, updateState, config, setCfg, ...data })
            let feeCalculationAttr = await buildAttr({ formData: newFormData, args: 'ccy' })
            let keyLabelArray = [];
            if (rssiResp.rcvrCorrBicList && typeof rssiResp.rcvrCorrBicList === 'string') {
                let rcvrCorrBicList = JSON.parse(rssiResp.rcvrCorrBicList);
                Object.keys(rcvrCorrBicList).forEach((e) => {
                    if (e && typeof e === 'string') {
                        keyLabelArray.push({
                            val: e,
                            lbl: rcvrCorrBicList[e]
                        })
                    }
                })
            }
            newFormData = { ...newFormData, ...rssiResp, dynSelectRecCorsBic: keyLabelArray }
            if (rssiResp && rssiResp.rssiRspnStatus && rssiResp.rssiRspnStatus === '00') {
                updateState({ newFormData: newFormData, newAttr: {...feeCalculationAttr, sndrCorrBic: {}, cdtrBnkCntrycd:{}} })
                return;
            } else if (rssiResp && rssiResp.rssiRspnStatus && rssiResp.rssiRspnStatus !== '00') {
                let appendErrorMsg = rssiResp.rssiRespDesc.startsWith("Unable") ? '' : translateFormMsg('rssi_error_msg');
                let newMsg = { key: appendErrorMsg + rssiResp.rssiRespDesc, type: AlertType.W };
                updateState({ newFormData: newFormData, newMsg, newAttr: {...feeCalculationAttr, cdtrBnkCntrycd: {}}  })
                return;
            }
        } else {
            updateState({ newFormData,  newAttr: {cdtrBnkCntrycd:{}}})
        }
    } else {
        // BIC entered but no matching bank found — clear stale auto-populated fields too
        let clearedFormData = {
            ...formData,
            cdtrBnkNm: '',
            cdtrBnkCntrycd: '',
            cdtrBnkAddr1: '',
            cdtrBnkAddr2: ''
        }
        updateState({ newFormData: clearedFormData })
    }
}

const prefCorrBicOnChange = async ({ props, ctrlCfg, formData, updateState, config, setCfg, ...data }) => {
    if (formData.recvCorrPrefSSI === '') {
        await creditCcyOnChange({ props, ctrlCfg, formData: { ...formData, rcvrCorrBic: '', isFromPrefCorrBic: true }, updateState, config, setCfg, ...data });
        return;
    }

    let rssiForm = { ...formData, rcvrCorrBic: formData.recvCorrPrefSSI };

    let rssiResp = await rssiApiCall({ props, ctrlCfg, formData: rssiForm, updateState, config, setCfg, ...data })
    let nForm = { ...formData }
    let keyLabelArray = [];
    if (rssiResp.rcvrCorrBicList && typeof rssiResp.rcvrCorrBicList === 'string') {
        let rcvrCorrBicList = JSON.parse(rssiResp.rcvrCorrBicList);
        Object.keys(rcvrCorrBicList).forEach((e) => {
            if (e && typeof e === 'string') {
                keyLabelArray.push({
                    val: e,
                    lbl: rcvrCorrBicList[e]
                })
            }
        })
        nForm = { ...nForm, ...rssiResp, dynSelectRecCorsBic: keyLabelArray }
    }
    if (rssiResp && rssiResp.rssiRspnStatus && rssiResp.rssiRspnStatus !== '00') {
        let newMsg = { key: translateFormMsg('rssi_error_msg') + ": " + rssiResp.rssiRespDesc, type: AlertType.W };
        updateState({ newFormData: { ...nForm, rcvrCorrBic: '' }, newMsg })
        return;
    }
    updateState({ newFormData: nForm })
}

const rcvrCorrBicOnChange = async ({ props, ctrlCfg, formData, updateState, showCustomModal, hideCustomModal, config, setCfg, ...data }) => {
    if (formData.rcvrCorrBic === '') {
        updateState({ newFormData: formData })
        return;
    }
    if (formData.rssiRspnStatus !== '00') {
        const message = translateFormMsg('rssi_dialog_confirm_msg', formData, props.field.moduleId);
        const title = translateFormMsg('rssi_dialog_confirm_title', formData, props.field.moduleId);
        showCustomModal({
            content: (
                <YesNoModel message={message}
                    onYes={async () => {
                        hideCustomModal?.();
                        let {recvCorrPrefSSI, ...rssiResp} = await rssiApiCall({ props, ctrlCfg, formData: {...formData, recvCorrPrefSSI: ''}, updateState, config, setCfg, ...data })
                        let keyLabelArray = [];
                        if (rssiResp.rcvrCorrBicList && typeof rssiResp.rcvrCorrBicList === 'string') {
                            let rcvrCorrBicList = JSON.parse(rssiResp.rcvrCorrBicList);
                            Object.keys(rcvrCorrBicList).forEach((e) => {
                                if (e && typeof e === 'string') {
                                    keyLabelArray.push({
                                        val: e,
                                        lbl: rcvrCorrBicList[e]
                                    })
                                }
                            })
                        }
                        let nForm = { ...formData, ...rssiResp, dynSelectRecCorsBic: keyLabelArray  }
                        updateState({ newFormData: nForm })
                    }}
                    onNo={() => { hideCustomModal?.(); }}
                />
            ),
            width: '520px',
            title: title,
        });
        return;
    } else {
        let rssiResp = await rssiApiCall({ props, ctrlCfg, formData, updateState, config, setCfg, ...data })
        let nForm = { ...formData, ...rssiResp }
        updateState({ newFormData: nForm })
    }
}

const rssiUtilCall = async (formData) => {
    let rssiRes = {}

    if (formData.creditCcy !== '' && formData.acctToBic !== '' && formData.cdtrBnkCntrycd !== '') {
        rssiRes = await post('rssi', 'rssi-call', formData)
        console.log('rssi-call val', rssiRes)

        if (rssiRes?.rssiRspnStatus !== '00' && rssiRes?.rssiRespDesc !== '') {
            let newMsg1 = translateFormMsg('rssi_error_msg') + ": " + rssiRes?.rssiRespDesc;
            alert(rssiRes?.newMsg1)
        }
    }

    return rssiRes
}

const dbtrBnkCntrycdHandle = async ({ props, formData, updateState, config, setCfg, ...data }) => {
    let dbtrBnkCntrycd = formData.dbtrBnkCntrycd
    let dbtrTwnNm = formData.dbtrTwnNm

    if (dbtrBnkCntrycd === '') {
        return;
    }

    if (dbtrBnkCntrycd === 'SG') {
        dbtrTwnNm = 'Singapore'
    }

    let newFormData = {
        ...formData,
        dbtrTwnNm
    }

    updateState({ newFormData })
}

const cdtrCntryCdHandle = async ({ props, formData, updateState, config, setCfg, ...data }) => {
    let cdtrCntryCd = formData.cdtrCntryCd
    let cdtrTwnNm = formData.cdtrTwnNm

    if (cdtrCntryCd === '') {
        return;
    }

    if (cdtrCntryCd === 'SG') {
        cdtrTwnNm = 'Singapore'
    }

    let newFormData = {
        ...formData,
        cdtrTwnNm
    }

    updateState({ newFormData })
}
const rtHolidayChk = async ({ props, changeView, formData, activeTab, updateState, ...data }) => {
    let nattr = { ...data.attr }
    if (formData.debitCcy !== "") {

        const payload = {
            productMode: formData.productMode ?? "RT",
            txCd: formData.txCd,
            valueDt: formData.valueDt,
            debitCcy: formData.debitCcy,
            creditCcy: formData.creditCcy,
        };
        let val = await post('holiday', 'holiday-chk', payload);

        if (val.localholiday && val.localholiday === "Y") {
            let newMsg = { key: translateFormMsg("holiday_msg"), type: AlertType.W };
            let attributes = nattr["ccy"] || {}
            delete attributes['err'];
            nattr["debitCcy"] = { ...attributes, err: "debitCcy_holiday" };
            nattr["create"] = { disabled: true }
            updateState({ newFormData: formData, newMsg, newAttr: nattr })
            return true;
        } else if (val.debitHoliday && val.debitHoliday === "Y") {
            //let newMsg = { key: translateFormMsg("ccy_holiday_msg"), type: AlertType.W };
            let attributes = nattr["ccy"] || {}
            delete attributes['err'];
            nattr["ccy"] = { ...attributes, err: "debitCcy_holiday" };
            nattr["debitCcy"] = { ...attributes, err: "debitCcy_holiday" };
            nattr["create"] = { disabled: true }
            updateState({ newFormData: formData,newAttr: nattr })
            return true;
        } else if (val.creditHoliday && val.creditHoliday === "Y") {
            //let newMsg = { key: translateFormMsg("ccy_holiday_msg"), type: AlertType.W };
            let attributes = nattr["creditCcy"] || {}
            delete attributes['err'];
            nattr["creditCcy"] = { ...attributes, err: "creditCcy_holiday" };
            updateState({ newFormData: formData,newAttr: nattr })
            return true;
        }
    }
    return false;
}
const rtSubmitDialogMkrDecline = async ({ props, submitConfirm, handleApiError, config, formData, updateState, validate, showDialog, showCustomModal, hideCustomModal, showSummary, clearForm, loadCfg, modNm, mtype, changeView, navigate, activeTab, ...data }) => {
    const btnAction = props.field && props.field.name ? props.field.name : '';
    const module = props.field?.module || formData?.module || modNm;

    let action = config.pages[config.cPKey].action || 'summary';
    let modPK = config.pages[config.cPKey].modPK || '';
    let parentPK = formData.parentPK || '';
    let val = await post('md-mod-cfg', 'validate', { module: props.field.module, action: action, ...formData, mtype: mtype, wuiFldProps: { field: props.field }, modPK: modPK, parentPK: parentPK }, navigate);
    if (handleApiError(val, { ...data, module: props.field.module, updateState })) {
        return;
    }
    let table = { ...formData.table, ...val.table }
    let nFormData = { ...formData, ...val, table: { ...table } };

    let labels = {
        title: "Online Outward Payment Confirmation",
        description: `Are you sure you want to decline the request ?`
    }

    showCustomModal({
        content: (
            <YesNoModel message={labels.description}
                onYes={() => {
                    hideCustomModal?.();
                    submitConfirm({ props, formData: nFormData, updateState, validate, showDialog, showCustomModal, hideCustomModal, showSummary, clearForm, loadCfg, modNm, mtype, ...data });
                }}
                onNo={() => { hideCustomModal?.(); }}
            />
        ),
        width: '520px',
        title: labels.title,
    });
}


export {
    feeCalculation, debitCcyOnChange, getAcctInfo, attrBicHandle, creditCcyOnChange, dbtrBnkCntrycdHandle,
    cdtrCntryCdHandle, rcvrCorrBicOnChange, getAcctInfoChkr, debtCcyChange, prefCorrBicOnChange,rtHolidayChk,
    rssiUtilCall,rtSubmitDialogMkrDecline,feeAndExchangeRateCalculation,debtCcyChangeFromGetAcctInfo
}